import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    selectionCardContainer: {
      justifyContent: 'space-around',
      background: 'transparent',
      marginBottom: '20px',
      [theme.breakpoints.down('lg')]: {
        gap: '25px',
        paddingTop: '25px',
        minHeight: '1300px',
        alignItems: 'center'
      }
    }
  })
);
